import Image from "assets/png/about-hero.png";
import Icon1 from "assets/svg/safe.svg";
import Icon2 from "assets/svg/cam.svg";

const Hero = () => {
  return (
    <div className="hero py-16">
      <div className="section-container no-pad">
        <div className="section-grid-2">
          <div className="section-content o-2">
            <p className="header pry-text purple">
              <span className="gray">27 Years of Excellence</span> in Security
              Services
            </p>

            <div className="sec-body sm-width">
              <p className="content black pry-text !w-full">
                At Noble Guard Security, we provide trusted and professional
                security services across Nigeria. With over 27 years in the
                industry, we safeguard lives and businesses using cutting-edge
                technology and highly trained personnel.
              </p>
            </div>
          </div>

          <img src={Image} alt="" className="section-img o-1" />
        </div>
      </div>

      <div className="!hidden !lg:flex atom-row px-8 lg:px-24">
        <img src={Icon2} alt="" className="frame-icon" />
        <img src={Icon1} alt="" className="frame-icon" />
      </div>
    </div>
  );
};

export default Hero;
